import { render } from "./Devices.vue?vue&type=template&id=221de6c2"
import script from "./Devices.vue?vue&type=script&lang=js"
export * from "./Devices.vue?vue&type=script&lang=js"
script.render = render

export default script